import React from "react";

const formatTitle = (title) => {
    const colonIndex = title.indexOf(':');
    if (colonIndex >= 10) {
        return (
            <>
                {title.slice(0, colonIndex + 1)}
                <br />
                {title.slice(colonIndex + 1).trimStart()}
            </>
        );
    }
    return title;
};

export default ({
    children,
    title = "Missing Title",
    width = "1024px",
    height = "542px",
    author_avatar = "https://indyhall.org/assets/images/indy-hall.png",
    author_name = "Indy Hall",
}) => {
    const styles = {
        width: width,
        height: height,
    };
    return (
        <div id="social-card" className="social-card" style={styles}>
            <div className="header-bar">
                <span className="label">INDY HALL</span>
                <span className="site">indyhall.org</span>
            </div>
            <div className="content">
                <h1 className="title">{formatTitle(title)}</h1>
            </div>
            <div className="footer">
                <div className="author">
                    <img src={author_avatar} alt={author_name} />
                </div>
            </div>
        </div>
    );
};
